import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { storageService } from "services/storageService";
import { getPostLoginRedirectPath } from "util/moduleAccess";

export default function PublicRoute() {
  const token = storageService.getItem("accessToken");
  const { pathname, search } = useLocation();

  // Reset password links use a token query param and must remain publicly accessible.
  if (pathname === "/reset-password") {
    return <Outlet />;
  }

  if (token) {
    return <Navigate to={getPostLoginRedirectPath(token)} replace />;
  }

  // OAuth callback lands on root with ?token= or ?discovery_token=
  // Forward to SelectOrganization which handles both.
  // Keep this scoped to root/login so reset-password query tokens are unaffected.
  const params = new URLSearchParams(search);
  const isAuthCallbackPath = pathname === "/" || pathname === "/login";
  if (isAuthCallbackPath && (params.get("token") || params.get("discovery_token"))) {
    return <Navigate to={`/select-organization${search}`} replace />;
  }

  return <Outlet />;
}